import { Component } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';

import { ContratoService } from '../../../../../providers/contrato-service';
import { AlertService } from '../../../../../providers/alert-service';
import { MenuService } from '../../../../../providers/menu-service';
import { ModulosController } from '../../../modulos-controller';
import { UsuarioService } from '../../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../../providers/gestao-pca-service';

import { ModalProdutoContratoPage } from '../../../../modais/modal-produto-contrato/modal-produto-contrato';
import { ModalArquivosPage } from '../../../../modais/modal-arquivos/modal-arquivos';

@Component({
    selector: 'page-lista-contratos',
    templateUrl: 'lista-contratos.html',
    providers: [
        ContratoService
    ]
})
export class ListaContratosPage extends ModulosController {
    listaDados: any;
    loading: boolean = true;
    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "50";
    pageListaContratos: number = 1;
    loadingPagContrato: boolean = true;

    pagination = {
      TotalItems: 100,
      CurrentPage: 1,
      PageSize: 10,
      TotalPageLinkButtons: 5,
      RowsPerPageOptions: [10]
    };

    filter: any = { nmContrato: '' };

    order: string = 'nmAditivo';
    reverse: boolean = false;

    idModuloPca: any;
    analise: any;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public contratoService: ContratoService,
        public gestaoPcaService: GestaoPcaService,
        //private fileService: FileService
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

        this.idModuloPca = this.navParams.get('analise').idModuloPca;
        this.analise = this.navParams.get('analise');

        this.carregarDados();

        this.setModuloId(5);
        this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
    }

    setOrder(value: string) {
        if (this.order === value) {
            this.reverse = !this.reverse;
        }

        this.order = value;
    }

    carregarDados() {

        this.contratoService.listarPorPCAPag(1, '').subscribe(data => {
            this.listaDados = data.contratosModel;
            this.loadingPagContrato = this.loading = false;
            this.pagination.TotalItems = data.qtdPags;
        }, error => {
            console.log("erro: " + error);
            this.loadingPagContrato = this.loading = false;
        });
    }

    formatarPorcentagem(valor) {
        return valor.toString().replace('.', ',') + "%";
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltar() {
        this.menuService.redirecionarPagina(this.contratoService.obterIdPaginaContrato());
    }

    adicionarProdutos(aditivo) {
        let titulo = "Produtos do Aditivo " + aditivo.nmAditivo;

        let modal = this.modalCtrl.create(ModalProdutoContratoPage,
            {
                param1: titulo,
                aditivo: aditivo,
                jurisdicionado: false,
                idModuloPca: this.idModuloPca
            });
        modal.onDidDismiss(retornoModal => {
            if (retornoModal && retornoModal.flag) {
                this.carregarDados();
            }
        });

        modal.present();
    }

    // abrirTermoReferencia(contrato) {
    //     let titulo = "Documentos";

    //     let modal = this.modalCtrl.create(ModalTermoReferenciaAditivoPage,
    //         {
    //             titulo: titulo,
    //             contrato: contrato,
    //             isJurisdicionado: false
    //         });
    //     modal.onDidDismiss(retornoModal => {
    //         if (retornoModal && retornoModal.flag) {
    //         }
    //     });

    //     modal.present();
    // }

    abrirTermoReferencia(item) {
        let titulo = "Documentos";

        let modal = this.modalCtrl.create(ModalArquivosPage,
            {
                titulo: titulo,
                IdProcesso: item.nmContrato,
                idModuloPCA: this.idModuloPca,
                tipoAnalise: '49',
                jurisdicionado: this.isJurisdicionado,
                isCGE: this.isCGE,
                origemArquivo: "Contrato: " + item.nmContrato,
                origemFilter: 'CONTRATO',
                tipoEntidadeExercicio: 0,
                tipodocumento: 0,
                analise: this.analise
            });
        modal.onDidDismiss(retornoModal => {
            if (retornoModal && retornoModal.flag) {
            }
        });

        modal.present();
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 20;

        if (text != undefined) {
            let separatedByWords = text.toString().split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.toString().split(" ");
        let numberOfWordsToTruncate = 20;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

    salvarComentario(enviarMensagem = true) {
        this.loading = true;
        if (this.listaDados) {
            this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
            this.contratoService.salvarDadosAnaliseNotaEmpenho(this.listaDados, this.idSecaoPagina).subscribe(data => {

                if (enviarMensagem) {
                    this.alertService.mostraAlerta("", "Salvo com sucesso.");
                }
                this.loading = false;
            }, error => {
                if (enviarMensagem) {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
                }
                this.loading = false;
            });
        }
    }

    submeterNoCertificado() {
        this.loading = true;
        if (this.listaDados.resultadoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.resultadoAnalise == null || this.listaDados.resultadoAnalise == undefined || !this.listaDados.resultadoAnalise) {
            this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
            this.loading = false;
        } else {
            if (this.listaDados) {
                this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
                this.salvarComentario(false);

                var jsonSubmeter = {
                    "idModuloAnalise": this.listaDados.idModuloAnalise,
                    "dsResultadoAnalise": this.listaDados.resultadoAnalise
                }

                this.contratoService.submeterAnalise(jsonSubmeter, this.idSecaoPagina).subscribe(data => {
                    this.alertService.mostraAlerta("", "Submetido com sucesso.");
                    this.voltar();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                    this.loading = false;
                });
            }
        }
    }

    formatarZeroEsquerda(valor) {
        return valor.replace(/^0+(?!\.|$)/, '');
    }

    capitalize(str) {
        let retorno = "";

        if (str) {
            retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }

        return retorno;
    }

    loadPage(Page: any) {
        console.log(Page);
        this.pagination.CurrentPage = Page;
        this.loadingPagContrato = true;
        this.contratoService.listarPorPCAPag(Page, this.filter.nmContrato).subscribe(data => {
            this.listaDados = data.contratosModel;
            this.loadingPagContrato = this.loading = false;
            this.pagination.TotalItems = data.qtdPags;
        }, error => {
            console.log("erro: " + error.mensagem);
            this.loadingPagContrato = this.loading = false;
        });
    }

    filtraContratos() {
        if (this.filter.nmContrato.length > 2 || this.filter.nmContrato.length == 0) {
            this.loadPage(1);
        }
    }
}




// WEBPACK FOOTER //
// ./src/pages/modulos/contratos/contrato-analise/lista-contratos/lista-contratos.ts